<h1 mat-dialog-title>Attention</h1>
<div mat-dialog-content>Data shown in contact List and messages of selected contacts is dummy data. </div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close style="text-align: center;">Close</button>
</div>